import { render, staticRenderFns } from "./MyCallsDatewiseTable.vue?vue&type=template&id=1c34cded&scoped=true&"
import script from "./MyCallsDatewiseTable.vue?vue&type=script&lang=js&"
export * from "./MyCallsDatewiseTable.vue?vue&type=script&lang=js&"
import style0 from "./MyCallsDatewiseTable.vue?vue&type=style&index=0&id=1c34cded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34cded",
  null
  
)

export default component.exports